import React, { Suspense, useEffect, useRef } from "react";
import { Container, LContent, Main, RightContainer } from "./layout.style";
import AsidMenu from "@/components/container/AsidMenu/AsidMenu";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { MenuProps } from "antd";
import Header from "@/components/container/Header/Header";

export const LayoutCom: React.FC = () => {
  // 点击侧边栏选项的事件
  const clickMenuItem: MenuProps["onClick"] = (e) => {
    selectTab.current = e.key;
  };

  const navigator = useNavigate();
  const location = useLocation();
  // 存放侧边栏当前选中的tab值
  const defaultSelectTab = useRef<string[]>([
    location.pathname === "/" ? "/admin/dataCenter" : location.pathname,
  ]);
  const selectTab = useRef(
    location.pathname === "/" ? "/admin/dataCenter" : location.pathname

  );

  useEffect(() => {
    if (localStorage.getItem("come-to-chant-token")) {
      location.pathname === "/" && navigator("/admin/dataCenter");
    } else {
      navigator("/login");
    }
  }, [location.pathname, navigator]);

  return (
    <Container>
      <AsidMenu
        click={clickMenuItem}
        defaultSelectTab={defaultSelectTab.current}
        selectTab={selectTab.current}
      />
      <RightContainer>
        <Header />
        <LContent>
          <Main>
            <Suspense>
              <Outlet />
            </Suspense>
          </Main>
        </LContent>
      </RightContainer>
    </Container>

  );
};

export default LayoutCom;
